import { Type } from '@angular/core';

import { IconChevronDownComponent } from './icon-chevron-down.component';
import { IconChevronLeftComponent } from './icon-chevron-left.component';
import { IconChevronRightComponent } from './icon-chevron-right.component';
import { IconChevronUpComponent } from './icon-chevron-up.component';
import { IconHomeComponent } from './icon-home.component';
import { IconTimesComponent } from './icon-times.component';

export const ICON_COMPONENTS: Array<Type<any>> = [
    IconChevronDownComponent,
    IconChevronLeftComponent,
    IconChevronRightComponent,
    IconChevronUpComponent,
    IconHomeComponent,
    IconTimesComponent,
];
